<template>
  <l-marker
    :key="marker.number"
    :lat-lng="[marker.lat, marker.lng]"
    :options="leafletMarkerOptions"
  >
    <l-icon ref="icon">
      <router-link
        :to="{
          name: 'liste-entreprises',
          params: {
            slug: marker.slug,
          },
        }"
        ref="marker"
        class="marker"
        :class="$route.params.slug === marker.slug ? 'opened' : ''"
      >
        {{ marker.number }}
      </router-link>
    </l-icon>
  </l-marker>
</template>

<script>
import { LIcon, LMarker } from "vue2-leaflet";
export default {
  components: { LIcon, LMarker },
  props: {
    marker: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      leafletMarkerOptions: {
        riseOnHover: true,
        title: this.marker.markerFullAdresse,
      },
      // leafletPopupOptions: {
      //   closeButton: false,
      // },
    };
  },
  methods: {
    // entrepriseOpened() {
    //   this.$root.$emit("center-marker", [
    //     this.marker.markerLat,
    //     this.marker.markerLng,
    //   ]);
    // },
  },
};
</script>

<style lang="scss" scoped>
.marker {
  width: 30px;
  height: 30px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  font-size: 12px;
  font-weight: 600;
  line-height: 150%;
  text-decoration: none;
  border-radius: 50%;
  // border: solid 1px rgba(255, 255, 255, 0.3);
  // box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.25);
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  transform: translate(-50%, -50%) scale(1);
  transition: transform 0.3s var(--bounce);
  &:hover,
  &.opened,
  &:focus,
  &:active {
    background-color: var(--green);
    color: var(--white);
    transform: translate(-51%, -51%) scale(1.1);
    transition: transform 0.3s var(--bounce);
  }
}
</style>
